import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ApcAdderService from "./ApcAdderService";

export const GetAllAPCAdders = createAsyncThunk(
    "apc-adders/index", async(_, thunkAPI) => {
        let {getState, rejectWithValue} = thunkAPI;
        try {
            return await ApcAdderService.GetAllAPCAdders();
        } catch (error)
        {
            let message = error.message
            return rejectWithValue(message)
        }
    }
)

export const CreateAPC = createAsyncThunk(
    "apc-adders/create", async (data, thunkAPI) => {
        let {rejectWithValue, getState} = thunkAPI;
        try {
            return await ApcAdderService.CreateAPC(data)
        } catch (error)
        {
            let message = error.message
            return rejectWithValue(message)
        }
    }
)

export const DeleteAPC = createAsyncThunk(
    "apc-adders/delete", async (apc_id, thunkAPI) => {
        let {rejectWithValue, getState} = thunkAPI;
        try {
            return await ApcAdderService.DeleteAPC(apc_id)
        } catch (error)
        {
            let message = error.message
            return rejectWithValue(message)
        }
    }
)

const ApcAdder = createSlice({
    name: "ApcAdder",
    initialState: {
        apc: {},
        isSuccess: false,
        isError: false,
        isLoading: false,
        message: "",
    },
    reducers: {
        apcReset: (state) => {
            state.isError = false;
            state.isSuccess = false;
            state.isLoading = false;
            state.message = ""
        }
    },
    extraReducers:{
        // GetAllAPC
        [GetAllAPCAdders.pending]: (state) => {
            state.isLoading = true
        },
        [GetAllAPCAdders.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.apc = action.payload
        },
        [GetAllAPCAdders.rejected]: (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.message = action.payload
        },
        // Create APC
        [CreateAPC.pending]: (state) => {
            state.isLoading = true
        },
        [CreateAPC.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
        },
        [CreateAPC.rejected]: (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.message = action.payload
        },
        // Delete APC
        [DeleteAPC.pending]: (state) => {
            state.isLoading = true
        },
        [DeleteAPC.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
        },
        [DeleteAPC.rejected]: (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.message = action.payload
        }
    }
})


export const {apcReset} = ApcAdder.actions
export default ApcAdder.reducer